import { useTranslation } from 'react-i18next'
import AppPreview from '@/assets/icons/AppPreview'

interface AppDesignPreviewProps {
  accentColor: string | null | undefined
  logoUrl: string | null | undefined
}

export function AppDesignPreview({ accentColor, logoUrl }: AppDesignPreviewProps) {
  const { t } = useTranslation('configuration')

  return (
    <div className="flex flex-col gap-3">
      <p className="text-sm font-semibold">{t('preview.title')}</p>

      <div className="relative w-[250px]">
        {/* Company logo overlaid on the phone's header area */}
        <div className="absolute left-5 top-10 flex h-[35px] w-[120px]">
          {logoUrl && (
            <img
              key={logoUrl}
              src={logoUrl}
              height="100%"
              style={{ objectFit: 'contain', maxWidth: '100%' }}
              alt=""
            />
          )}
        </div>
        <AppPreview color={accentColor ?? 'transparent'} />
      </div>
    </div>
  )
}
